import { FahrlehrerCh } from '@/src/@types/blinkadmin'

export type CrosslinkOffer = 'lessons' | 'firstaid' | 'vku' | 'pgs' | 'wab'

export type CrosslinksData = {
  currentOffer: CrosslinkOffer
  nearbyLocations: FahrlehrerCh.LocationWithDistance[]
  otherOffers: FahrlehrerCh.OtherOffers
}

export type CrosslinkRow = {
  key: string
  label: string
  distanceKm: number
  href: string
}

const OFFER_ORDER: (keyof FahrlehrerCh.OtherOffers)[] = [
  'lessons',
  'firstaid',
  'vku',
  'pgs',
]

const OFFER_LABELS: Record<CrosslinkOffer, string> = {
  lessons: 'Fahrlehrer:innen',
  firstaid: 'Nothelferkurs',
  vku: 'VKU',
  pgs: 'Motorradgrundkurs',
  wab: 'WAB Kurs',
}

export const OFFER_NEARBY_HEADINGS: Record<CrosslinkOffer, string> = {
  lessons: 'Fahrlehrer:innen in der Nähe',
  firstaid: 'Nothelferkurse in der Nähe',
  vku: 'Verkehrskundeunterricht in der Nähe',
  pgs: 'Motorradgrundkurse in der Nähe',
  wab: 'WAB Kurse in der Nähe',
}

export function getNearbyRows(data: CrosslinksData): CrosslinkRow[] {
  const label = OFFER_LABELS[data.currentOffer]
  return data.nearbyLocations.map((location) => ({
    key: String(location.locationId),
    label: `${label} in ${location.locationName}`,
    distanceKm: location.distanceKm,
    href: location.locationSlug,
  }))
}

export function getOtherOfferRows(data: CrosslinksData): CrosslinkRow[] {
  const rows: CrosslinkRow[] = []
  for (const offer of OFFER_ORDER) {
    if (offer === data.currentOffer) continue
    const location = data.otherOffers[offer]
    if (!location) continue
    rows.push({
      key: offer,
      label: `${OFFER_LABELS[offer]} in ${location.locationName}`,
      distanceKm: location.distanceKm,
      href: location.locationSlug,
    })
  }
  return rows
}

export function getOtherOffersHeading(
  data: CrosslinksData,
  locationName: string
): { title: string; subtitle: string } {
  if (data.currentOffer === 'lessons') {
    return {
      title: `Kurse in der Nähe von ${locationName}`,
      subtitle: 'Obligatorische Kurse direkt bei uns',
    }
  }
  return {
    title: `Weitere Angebote in der Nähe von ${locationName}`,
    subtitle: 'Alles rund um deine Fahrausbildung',
  }
}
